import React, { useMemo, useState } from "react";
import NoBriefView from "../../../../components/no-briefs";
import { FilterChips } from "../../../../components/filters/components/filter-chips/filter-chips.components";
import { SpinnerLoader } from "../../../../components/loaders";
import { BriefListViewType } from "../../types/brief-list-view-type.enum";
import { BriefListProps } from "./brief-list.props";
import { BriefListToday } from "../brief-list-today/brief-list-today.component";
import { BriefProps } from "../../types/props/brief-props.type";
import { BriefListTableView } from "../brief-list-table-view/brief-list-table-view.component";
import { BriefListPaginator } from "../brief-list-paginator/brief-list-paginator.component";
import {
  BriefListBeforeSevenDaysHeader,
  BriefListPrevSevenDaysHeader,
  BriefListTodayHeader,
} from "../../types/brief-list.constants";
import {
  filterByBeforeSevenDays,
  filterByPrevSevenDays,
  filterByTodayDate,
} from "../../types/brief-list-date.functions";

export default function BriefList(props: BriefListProps) {
  const { dataList, pageCount = 0 } = props;

  const [viewType, setViewType] = useState(BriefListViewType.GRID_VIEW);

  const todayList = useMemo(() => filterByTodayDate(dataList as BriefProps[]), [dataList]);
  const prevSevenDaysList = useMemo(() => filterByPrevSevenDays(dataList as BriefProps[]), [
    dataList,
  ]);
  const beforeSevenDaysList = useMemo(() => filterByBeforeSevenDays(dataList as BriefProps[]), [
    dataList,
  ]);

  const dataListForGrid = () => {
    const sevenHeader = prevSevenDaysList.length < 1 ? [] : [BriefListPrevSevenDaysHeader];
    const earlierHeader = beforeSevenDaysList.length < 1 ? [] : [BriefListBeforeSevenDaysHeader];
    return [...sevenHeader, ...prevSevenDaysList, ...earlierHeader, ...beforeSevenDaysList];
  };

  const dataListForList = () => {
    const tHeader = todayList.length < 1 ? [] : [BriefListTodayHeader];
    const sevenHeader = prevSevenDaysList.length < 1 ? [] : [BriefListPrevSevenDaysHeader];
    const earlierHeader = beforeSevenDaysList.length < 1 ? [] : [BriefListBeforeSevenDaysHeader];

    return [
      ...tHeader,
      ...todayList,

      ...sevenHeader,
      ...prevSevenDaysList,

      ...earlierHeader,
      ...beforeSevenDaysList,
    ];
  };

  const showTodayView = () => Boolean(todayList.length);
  const showTableView = () =>
    Boolean(dataList.length) && !props.loading.inProgress && !todayList.length;

  return (
    <>
      <FilterChips filterType={props.briefType} optionLists={props.filterOptionLists} />
      <SpinnerLoader showIf={props.loading.inProgress} />
      <NoBriefView
        showIf={!props.loading.inProgress && !dataList.length}
        briefType={props.briefType}
      />
      <BriefListToday
        showIf={showTodayView()}
        todayList={filterByTodayDate(dataList as BriefProps[])}
        gridList={dataListForGrid()}
        listList={dataListForList()}
        briefType={props.briefType}
        viewType={viewType}
        onViewChange={setViewType}
      />
      <BriefListTableView
        showIf={showTableView()}
        dataList={dataListForList()}
        briefType={props.briefType}
      />
      <BriefListPaginator pageCount={pageCount} />
    </>
  );
}
